"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesResults = exports.SearchResultsCoursesList = exports.SearchResultCourse = exports.LearningDataService = void 0;
const tslib_1 = require("tslib");
const json2typescript_1 = require("json2typescript");
const search_1 = require("src/search");
const FilterableList_1 = require("Views/Partials/Components/FilterableList");
class LearningDataService {
    constructor(searchUrl, searchParams) {
        this.getDataForLearningComponent = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.searchApi
                .doSearch(this.searchParams, CoursesResults)
                .then(data => {
                return this.processSuccessResult(data);
            })
                .catch(error => {
                return this.processFailResult(error);
            });
        });
        this.processSuccessResult = (data) => {
            const coursesData = data.documentList.documents;
            if (coursesData && coursesData.length > 0) {
                return {
                    coursesData: data.documentList.documents,
                    statusCode: FilterableList_1.ListStatusCode.success,
                };
            }
            return {
                coursesData: [],
                statusCode: FilterableList_1.ListStatusCode.zeroResults,
            };
        };
        this.processFailResult = (error) => {
            if (this.isCommunicationError(error)) {
                return {
                    statusCode: FilterableList_1.ListStatusCode.communicationError,
                    coursesData: [],
                };
            }
            throw new Error(error);
        };
        this.isCommunicationError = (error) => {
            return error && error.name === search_1.SEARCH_API_ERROR;
        };
        this.searchApi = new search_1.CoursesSearcherApi({
            url: searchUrl,
        });
        this.searchParams = searchParams;
    }
}
exports.LearningDataService = LearningDataService;
/* tslint:disable */
let SearchResultCourse = class SearchResultCourse {
    constructor() {
        this.id = undefined;
        this.name = undefined;
        this.type = undefined;
        this.language = undefined;
        this.description = undefined;
        this.learningType = undefined;
        this.deliveryTypes = undefined;
        this.duration = undefined;
        this.url = undefined;
    }
};
exports.SearchResultCourse = SearchResultCourse;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String, true),
    tslib_1.__metadata("design:type", String)
], SearchResultCourse.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('title', [String], true),
    tslib_1.__metadata("design:type", Array)
], SearchResultCourse.prototype, "name", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('course_type', String, true),
    tslib_1.__metadata("design:type", String)
], SearchResultCourse.prototype, "type", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('language', [String], true),
    tslib_1.__metadata("design:type", Array)
], SearchResultCourse.prototype, "language", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('description', [String], true),
    tslib_1.__metadata("design:type", Array)
], SearchResultCourse.prototype, "description", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('learning_type', String, true),
    tslib_1.__metadata("design:type", String)
], SearchResultCourse.prototype, "learningType", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('delivery_types', [String], true),
    tslib_1.__metadata("design:type", Array)
], SearchResultCourse.prototype, "deliveryTypes", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('duration', String, true),
    tslib_1.__metadata("design:type", String)
], SearchResultCourse.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('url', String, true),
    tslib_1.__metadata("design:type", String)
], SearchResultCourse.prototype, "url", void 0);
exports.SearchResultCourse = SearchResultCourse = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('SearchResultCourse')
], SearchResultCourse);
let SearchResultsCoursesList = class SearchResultsCoursesList {
    constructor() {
        this.documents = undefined;
    }
};
exports.SearchResultsCoursesList = SearchResultsCoursesList;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('documents', [SearchResultCourse]),
    tslib_1.__metadata("design:type", Array)
], SearchResultsCoursesList.prototype, "documents", void 0);
exports.SearchResultsCoursesList = SearchResultsCoursesList = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('SearchResultsCoursesList')
], SearchResultsCoursesList);
let CoursesResults = class CoursesResults {
    constructor() {
        this.documentList = undefined;
        this.courses = undefined;
    }
};
exports.CoursesResults = CoursesResults;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('documentList', SearchResultsCoursesList),
    tslib_1.__metadata("design:type", SearchResultsCoursesList)
], CoursesResults.prototype, "documentList", void 0);
exports.CoursesResults = CoursesResults = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('CoursesResults')
], CoursesResults);
/* tslint:enable */
